import { IApplicationState } from 'shared/types/redux';
import { ILandingState } from 'shared/types/features';

export const selectCalculatorDefaultValues = (state: IApplicationState): ILandingState['calculatorDefaultValues'] =>
  state.landing.calculatorDefaultValues;
